import { Box } from "@mui/material";
import { RiskType } from "../../../utils/constants";
import { RiskTypes } from "../../../type/enums";

interface CustomRiskTooltipProps {
  aiRisks: string;
  humanRisks?: string[];
}

interface TooltipLegendProps {
  legendText: string;
  isCircleIcon?: boolean;
  legendIconColor: "blue" | "red";
  mt?: number;
}
const TooltipLegend = ({
  legendText,
  isCircleIcon = false,
  legendIconColor,
  mt = 0,
}: TooltipLegendProps) => {
  return (
    <Box className="legend" mt={mt}>
      <Box
        className={`legend-icon ${
          isCircleIcon ? "legend-icon--circle" : ""
        } legend-icon--${legendIconColor}`}
      />
      <div>{legendText}</div>
    </Box>
  );
};

const CustomRiskTooltip = ({ aiRisks, humanRisks }: CustomRiskTooltipProps) => (
  <Box className="risk-tooltip-container">
    <TooltipLegend legendText="AI detected" legendIconColor="red" />
    <TooltipLegend
      legendText="Human detected"
      isCircleIcon
      legendIconColor="blue"
    />
    {aiRisks.split(",").map((risk, index) => (
      <TooltipLegend
        key={index}
        legendText={`${risk} - ${RiskType[risk.trim() as RiskTypes]}`}
        legendIconColor="red"
        mt={index === 0 ? 2 : 0}
      />
    ))}
    {humanRisks &&
      Array.from(new Set(humanRisks)).map((risk, index) => (
        <TooltipLegend
          key={index}
          legendText={`${risk} - ${RiskType[risk as RiskTypes]}`}
          legendIconColor="blue"
          isCircleIcon
          mt={index === 0 ? 2 : 0}
        />
      ))}
  </Box>
);

export default CustomRiskTooltip;
